module.exports = __webpack_public_path__ + "static/media/home_decor.68ce3021.jpg";